import { render, staticRenderFns } from "./apiUpdateProduct.vue?vue&type=template&id=15cc11ab&scoped=true&"
import script from "./apiUpdateProduct.vue?vue&type=script&lang=js&"
export * from "./apiUpdateProduct.vue?vue&type=script&lang=js&"
import style0 from "./apiUpdateProduct.vue?vue&type=style&index=0&id=15cc11ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cc11ab",
  null
  
)

export default component.exports